<template>
  <span class="company-container">
    <div class="header-area">
      <NavBarDark @challenge_clicked="signUp"></NavBarDark>
      <b-row class="text-left row-one">
              <b-col col lg="1" md="3" sm="2" cols="1">
              </b-col>
              <b-col col lg="6" md="6" sm="8" cols="10">
                  <h1 class="text-left heading">We help startups hire developers and designers</h1>
                  <div class="text-left second-heading">Assess and hire top talent</div>
                  <b-button v-on:click="getInTouch()" class="signup-btn">GET IN TOUCH</b-button><br><br>
              </b-col>
              <b-col col lg="4" md="7" sm="8" cols="10">
				<img class="gif-content" alt="product challenges" src="../assets/skill_testing_center.svg" height="243px" width="380px">
              </b-col>
              <b-col col lg="1" md="3" sm="2" cols="1">
              </b-col>
      </b-row>
    </div>
    <b-container fluid class="text-center">
    <h3 class="row-two-heading">Why us?</h3>
        <b-row class="row-two">
                <b-col col lg="2" md="3" sm="2" cols="1">
                </b-col>
                <b-col col lg="3" md="6" sm="8" cols="10">
                    <img width="300px" height="300px" src="../assets/company_hiring.svg" 
                    alt="practice challenges" class="img-fluid">
                </b-col>
                <b-col col lg="5" md="6" sm="8" cols="10" class="text-left point-one">
                    <div class="point-heading">
                      Screen to find the best candidates
                    </div>
                    <div class="point-content">
                      Use our automated and manual screening tests to assess top developers and designers quickly. We test for a variety of <b>skills</b> and <b>domains</b>.
                    </div><br>
                    <b-button v-on:click="getInTouch()" variant="outline" class="section-btns">START SCREENING</b-button>
                </b-col>
                <b-col col lg="2" md="3" sm="2" cols="1">
                </b-col>
        </b-row>
        <b-row class="row-two">
                <b-col col lg="1" md="1" sm="2" cols="1">
                </b-col>
                
                <b-col col lg="5" md="6" sm="8" cols="10" class="text-left point-one">
                    <div class="point-heading">
                      In-depth assignments and portfolio evaluation
                    </div>
                    <div class="point-content">
                      We combine all online portfolios and several data points for every candidate and our matching engine helps pick out the right candidates for your company.
                    </div><br>
                    <b-button v-on:click="getInTouch()" variant="outline" class="section-btns">EVALUATE PORTFOLIO</b-button>
                </b-col>
                <b-col col lg="1" md="1" sm="2" cols="1">
                </b-col>
                <b-col col lg="3" md="6" sm="8" cols="10">
                    <img width="300px" height="300px" src="../assets/online_portfolios.svg" 
                    alt="product jobs" class="img-fluid">
                </b-col>
                <b-col col lg="2" md="3" sm="2" cols="1">
                </b-col>
        </b-row>
        <b-row class="row-two">
                <b-col col lg="2" md="3" sm="2" cols="1">
                </b-col>
                <b-col col lg="3" md="6" sm="8" cols="10">
                    <img width="300px" height="300px" src="../assets/contact_us.svg" 
                    alt="hire product talent" class="img-fluid">
                </b-col>
                <b-col col lg="5" md="6" sm="8" cols="10" class="text-left point-one">
                    <div class="point-heading">
                      Anything else?
                    </div>
                    <div class="point-content">
                      For any other requirements, please feel free to contact us. We'd love to get in touch!
                    </div><br>
                    <b-button v-on:click="getInTouch()" variant="outline" class="section-btns">GET IN TOUCH</b-button>
                </b-col>
                <b-col col lg="2" md="3" sm="2" cols="1">
                </b-col>
        </b-row>
    </b-container>
    <div class="footer-component">
        <FooterDark></FooterDark>
    </div>
  </span>
</template>

<script>
// @ is an alias to /src
import NavBarDark from '@/components/NavBarDark.vue'
import FooterDark from '@/components/FooterDark.vue'
import firebase from '../services/firebase'
import router from '../router'
import Typed from 'typed.js';


export default {
  name: 'Home',
  components: {
    NavBarDark,
    FooterDark
  },
  methods: {
    getInTouch: function() {
      console.log("inside getInTouch, ready to send email");
      this.$router.push(this.$route.path + '/get-in-touch');
    },
    signUp: function() {
          console.log("inside signUp vue function");
          var provider = new firebase.auth.GoogleAuthProvider();
          var user = firebase.auth().currentUser;
          if (user === undefined || user === null) {
              firebase.auth().signInWithPopup(provider).then(function(result) {
                var user = result.user;
                var token = result.credential.accessToken;
                localStorage.token = token;
                var full_name = result.user.displayName;
                var first_name = full_name.split(" ");
                if (result.additionalUserInfo.isNewUser === true) {

                    mixpanel.identify(result.user.uid);
	  				mixpanel.track("first time user", {"email" : result.user.email});

                    firebase.database().ref("users/" + result.user.uid + "/").set({
                        email: result.user.email,
                        photoURL: result.user.photoURL,
                        name: result.user.displayName,
                        firstName: first_name[0]
                    });

                    mixpanel.register({
                        "name": result.user.displayName,
        				"email": result.user.email,
        				"first_name": first_name[0],
        				"id": result.user.uid,
        				"last_login": new Date()
                    });

                    mixpanel.people.set({
	  					"$name": result.user.displayName,
	  					"$email": result.user.email,
	  					"$first_name": first_name[0],
	  					"$id": result.user.uid,
	  					"$last_login": new Date()
	  				});

                }
                
                
                if (user) {
                    console.log("user with email" + user.email + "is signed in");
                    router.push('/dashboard');
                }
              }).catch(function(error) {
                console.log("signin error with errorCode" + error.code + " and message " + error.message); 
              })
          } else {
              console.log("email in Home is " + user.email);
              router.push('/dashboard');
          }
          
      }
  },
  mounted: function() {
      var typed = new Typed('.typed_element', {
          strings: ["UX/UI Designers", "React Native Developers", "Android Developers"],
          smartBackspace: true,
          typeSpeed: 100,
          loop: true,
          loopCount: Infinity,
          showCursor: false
      });
  }
}
</script>

<style scoped>

    .company-container {
        font-family: Avenir;
    }
 
    @media (min-width: 992px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px; 
            width:350px; 
            margin-top:0px;
        }
    }
    
    @media (max-width: 380px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px !important; 
            width:350px !important;
            margin: auto !important;
            margin-top:40px;
        }
    }

    @media (max-width: 576px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px; 
            width:350px;
            margin: auto !important;
            margin-top:40px;
        }
    }

    @media (min-width: 767px) and (max-width: 991px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px; 
            width:350px;
            margin: 45%;
            margin-top:40px;
        }
    }


    @media (min-width: 576px) and (max-width: 767px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px; 
            width:350px;
            margin: 20%;
            margin-top:40px;
        }
    }

    .gif-content {
        margin-left:0%; 
        margin-top:0%;
    }

    .signup-btn:hover {
        background-color:#f25792;
        color: #fff;
        border-color: #f25792;

    }

    @media (min-width:992px) {
       .signup-btn {
            margin-top:0%;
            padding-top:1.9%;
            padding-bottom:1.9%;
            padding-left:2.8%;
            padding-right:2.8%;
            justify-content: center;
            align-self: center;
            width:30%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius:7px;
            font-weight:500px;
        }    
    }

    @media (max-width:991px) and (min-width:701px){
       .signup-btn {
            margin-top:0%;
            padding-top:2.7% !important;
            padding-bottom:2.7% !important;
            padding-left:3%;
            padding-right:3%;
            justify-content: center;
            align-self: center;
            width:28%;
            margin-top:5%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }    
    }

    @media (max-width:700px) and (min-width:576px){
       .signup-btn {
            margin-top:5%;
            padding-top:3.4% !important;
            padding-bottom:3.4% !important;
            padding-left:3%;
            padding-right:3%;
            justify-content: center;
            align-self: center;
            width:37%;
            margin-bottom:10%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }    
    }

    @media (max-width:576px) {
       .signup-btn {
            margin-top:0%;
            padding-top:3.5%;
            padding-bottom:3.5%;
            padding-left:3.5%;
            padding-right:3.5%;
            justify-content: center;
            align-self: center;
            width:38%;
            margin-top:5%;
            margin-bottom:10%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }    
    }

    @media (max-width:380px) {
       .signup-btn {
            margin-top:0%;
            padding-top:4%;
            padding-bottom:4%;
            padding-left:5%;
            padding-right:5%;
            justify-content: center;
            align-self: center;
            width:40%;
            margin-top:5%;
            margin-bottom:10%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }    
    }    
    

    .header-area {
        color:#fff;
        /*background:linear-gradient(80deg, #5751d1, #798bf2); */
        background:linear-gradient(100deg, #5751d1, #6d7edb);
    }

    @media(max-width:576px) {
       .header-area {
            color:#fff;
            /*background:linear-gradient(80deg, #5751d1, #798bf2); */
            background:linear-gradient(100deg, #5751d1, #6d7edb);
            padding-bottom:40px;
        } 
    }

    .heading {
        font-size: 1.4rem !important;
        margin-top:3%;
    }

    .second-heading {
        font-size: 1.3rem !important;
        margin-top:4% !important;
        margin-bottom:8% !important;
        font-weight: 400;
    }

    @media (max-width: 410px) {
        .heading {
            font-size: 1.5rem !important;
            margin-top:3%;
        }

        .second-heading {
            font-size: 1.2rem !important;
            margin-top:15% !important;
            margin-bottom:8% !important;
            font-weight: 500;
        }
    }

    .row {
        margin-left: 0px;
        margin-right: 0px;
    }

    .row-one {
        padding-top:7%;
        padding-bottom:7% !important;
    }

    .row-two {
        padding-top:5%;
        padding-bottom:5%;
        background-color:#fff;
        color:#555;
        margin-bottom:5%;
    }

    .container-fluid {
        padding-top:3%;
        padding-bottom:5%;
        background-color:#fff;
        color:#555;
        width:100%;
    }

    .row-two-heading {
        text-align: center !important;
        margin-top:20px;
        margin-bottom:80px;
        font-weight: 500;
    }

    /*.btn-secondary {
        background-color:#f25792 !important;
        border-color: #f25792 !important;
        font-size:1.1rem !important;
        font-weight:500 !important;
        color: #fff !important;
        padding-left:3% !important;
        padding-right:3% !important;
        padding-top:1.5% !important;
        padding-bottom:1.5% !important;
    }*/

    .point-heading {
        color:#333; 
        text-align:left; 
        font-size:19px; 
        margin-top:10px;
        font-weight:500;
    }

    .point-content {
        text-align:left; 
        font-size:1rem; 
        margin-top:10px;
        color:#555;
    }

    .btn.section-btns.btn-outline{
        border-color:#f25792;
        color: #f25792;
        background-color: #fff;
        border:#f25792 solid 2px;
        border-radius: 7px;
    }

    .section-btns {
        border-color:#f25792;
        color: #f25792;
        background-color: #fff;
        border:#f25792 solid 2px;
        padding-left: 3.5%;
        padding-right: 3.5%;
        padding-top:2.4%;
        padding-bottom:2.4%;
        border-radius: 7px;
        font-size:0.8rem;
        margin-bottom:20px;
    }

    .point-one {
        margin-left:60px;
    }

</style>

